import { lazy } from 'react';

import { SchedulesLocalProvider } from 'modules/schedules/presentation/contexts';
import type { TRoute } from 'shared/presentation/modules/definitions';

const Reschedule = lazy(
  () => import('modules/schedules/presentation/pages/Reschedule'),
);
const RescheduleSetup = lazy(
  () => import('modules/schedules/presentation/pages/RescheduleSetup'),
);
const RescheduleUnits = lazy(
  () => import('modules/schedules/presentation/pages/RescheduleUnits'),
);
const Schedule = lazy(
  () => import('modules/schedules/presentation/pages/Schedule'),
);
const ScheduleContracts = lazy(
  () => import('modules/schedules/presentation/pages/ScheduleContracts'),
);
const SchedulePackages = lazy(
  () => import('modules/schedules/presentation/pages/SchedulePackages'),
);
const ScheduleSuccess = lazy(
  () => import('modules/schedules/presentation/pages/ScheduleSuccess'),
);
const ScheduleUnits = lazy(
  () => import('modules/schedules/presentation/pages/ScheduleUnits'),
);

const schedulesRoutes: TRoute[] = [
  {
    type: 'navigator',
    path: '/reagendamento',
    routes: [
      {
        type: 'route',
        authentication: 'private',
        path: '/reagendamento/horarios/:id',
        component: Reschedule,
        disabledTenancies: ['es', 'es-CR', 'es-UY'],
      },
      {
        type: 'route',
        authentication: 'private',
        path: '/reagendamento/unidade/:id',
        component: RescheduleUnits,
        disabledTenancies: ['es', 'es-CR', 'es-UY'],
      },
      {
        type: 'route',
        authentication: 'private',
        path: '/reagendamento/sucesso',
        component: ScheduleSuccess,
        disabledTenancies: ['es', 'es-CR', 'es-UY'],
      },
      {
        type: 'route',
        authentication: 'private',
        path: '/reagendamento/:id',
        component: RescheduleSetup,
        disabledTenancies: ['es', 'es-CR', 'es-UY'],
      },
    ],
    container: SchedulesLocalProvider,
  },
  {
    type: 'redirect',
    from: '/agendamento',
    to: '/agendamento/unidade',
    exact: true,
  },
  {
    type: 'redirect',
    from: '/agendamento/identificacao',
    to: '/agendamento/unidade',
    exact: true,
  },
  {
    type: 'navigator',
    path: '/agendamento',
    routes: [
      {
        type: 'route',
        authentication: 'private_by_document',
        path: '/agendamento/pacotes',
        component: SchedulePackages,
        disabledTenancies: ['es', 'es-CR'],
      },
      {
        type: 'route',
        authentication: 'private_by_document',
        path: '/agendamento/unidade',
        component: ScheduleUnits,
        disabledTenancies: ['es', 'es-CR'],
      },
      {
        type: 'route',
        authentication: 'private_by_document',
        path: '/agendamento/contratos',
        component: ScheduleContracts,
        disabledTenancies: ['es', 'es-CR'],
      },
      {
        type: 'route',
        authentication: 'private_by_document',
        path: '/agendamento/horarios',
        component: Schedule,
        disabledTenancies: ['es', 'es-CR'],
      },
      {
        type: 'route',
        authentication: 'private_by_document',
        path: '/agendamento/sucesso',
        component: ScheduleSuccess,
        disabledTenancies: ['es', 'es-CR'],
      },
    ],
    container: SchedulesLocalProvider,
  },
];

export default schedulesRoutes;
